"use client"
import { PostCardContent } from "@/app/(app)/(paragraph)/home/components/PostCardComponents/PostCardContent"
import { usePostEdit } from "@/app/contexts/PostEditContext"

export default function PostCardContentClient({
  blogName,
  blogIcon,
  publishedAt,
  description,
}: {
  blogName: string
  blogIcon?: string
  publishedAt: number
  description: string
}) {
  const { postPreview } = usePostEdit()

  return (
    <PostCardContent
      blogName={blogName}
      blogIcon={blogIcon}
      publishedAt={publishedAt}
      description={postPreview || description}
      size="MEDIUM"
    />
  )
}
